var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M2.516 10.751c.69-.689 1.807-.689 2.496 0l5.223 5.223V3.764a1.765 1.765 0 0 1 3.53 0v12.21l5.222-5.223a1.765 1.765 0 0 1 2.496 2.496l-8.236 8.235c-.689.69-1.806.69-2.495 0l-8.236-8.235a1.765 1.765 0 0 1 0-2.496",
    clipRule: "evenodd"
  })));
};
export default SvgArrowDown;